module.exports = __webpack_public_path__ + "media/assets/images/app/Landing/WhyUs__carousel__3-46a96af3e458d03d315d9daa22ad9275.jpg";